<header class="header">
    <div class="container">
        <div class="flex justify-between items-center">
            <div class="logo">
                <a routerLink="/" title="Shriram Wealth">
                    <img [ngSrc]="assetsCDNUrl+'/assets/images/wealth-logo.svg'" alt="Shriram Wealth" width="219"
                        height="92" class="w-[120px] xxl:w-[160px]">
                </a>
            </div>
            <div class="hamburger xl:!hidden">
                <button type="button" title="Hamburger Open" (click)="handler_hanburgerOpen()">
                    <img [ngSrc]="assetsCDNUrl+'/assets/images/header/hamburger-open.svg'" alt="Hamburger Open"
                        alt="Shriram Wealth" width="18" height="14">
                </button>
            </div>
            <nav class="navigation" #navigation>
                <button type="button" title="Hamburger Close" class="mb-8 xl:!hidden"
                    (click)="handler_hanburgerClose()">
                    <img [ngSrc]="assetsCDNUrl+'/assets/images/header/hamburger-close.svg'" alt="Hamburger Close"
                        alt="Shriram Wealth" width="18" height="14">
                </button>
                <div class="flex flex-col xl:flex-col-reverse">
                    <ul class="navigation__list">
                        <li>
                            <a routerLink="/" routerLinkActive="active" title="Home"
                                (click)="handler_hanburgerClose()">Home</a>
                        </li>
                        <li>
                            <a routerLink="about-us" routerLinkActive="active" title="About Us"
                                (click)="handler_hanburgerClose()">About Us</a>
                        </li>
                        <li>
                            <a routerLink="solutions" routerLinkActive="active" title="Solutions"
                                (click)="handler_hanburgerClose()">Solutions</a>
                        </li>
                        <li>
                            <a routerLink="insights" routerLinkActive="active" title="Insights"
                                (click)="handler_hanburgerClose()">Insights</a>
                        </li>
                        <li>
                            <a routerLink="media-corner" routerLinkActive="active" title="Media Corner"
                                (click)="handler_hanburgerClose()">Media Corner</a>
                        </li>
                        <li>
                            <a routerLink="career" routerLinkActive="active" title="Career"
                                (click)="handler_hanburgerClose()">Career</a>
                        </li>
                        <li>
                            <a routerLink="blog" routerLinkActive="active" title="Blog"
                                (click)="handler_hanburgerClose()">Blog</a>
                        </li>
                        <li>
                            <a routerLink="contact-us" routerLinkActive="active" title="Contact Us"
                                (click)="handler_hanburgerClose()">Contact Us</a>
                        </li>
                    </ul>
                    <ul class="navigation__topList">
                        <li>
                            <a routerLink="contact-us" title="Request a Call Back"
                                (click)="handler_hanburgerClose();handler_redirect(2)">Request a
                                Call Back</a>
                        </li>
                        <li>
                            <a href="https://swl.shriramwealth.in" title="Login" target="_blank"
                                rel="noopener noreferrer">Login</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</header>
<div class="header-backdrop" #headerBackdrop (click)="handler_hanburgerClose()"></div>